import { LayerTypeMapLayerProps } from "../../types";
import { MapLayer as ComparablesLayer } from "react-migration/domains/comparables/components/MapLayer/MapLayer";
import { useComparablesLayerContext } from "./ComparableLayerContext/useComparableLayerContext";

export function ComparablesMapLayer({ visible, zOrder, detailSelection }: Readonly<LayerTypeMapLayerProps>) {
  const { distribution } = useComparablesLayerContext();
  const deckGLAdjustedZoom = 13;

  return (
    <ComparablesLayer
      key="COMPARABLES"
      minZoom={deckGLAdjustedZoom}
      visible={visible && !detailSelection}
      distribution={distribution.data}
      zOrder={zOrder}
    />
  );
}
